import { Component, OnInit } from '@angular/core';
import { LeftSideNavComponent } from "../../../shared/layout/app/left-menu/left-side-nav.component";
import { HeaderComponent } from "../../../shared/layout/app/header/header.component";
import { TicketsBllService } from '../tickets-bll.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../../shared/components/loader/loader.service';
import { ProfileBllService } from '../../profile/profile-bll.service';
import { UserService } from '../../../core/services/user.service';
import { UserEventStatusRespModel } from '../../profile/profile.model';
import { APIErrorModel, BaseResponse } from '../../../shared/models/base-response.model';
import { CommonModule } from '@angular/common';
import { UpgradeTicketMediaPayload } from '../tickets.model';
import { HomeBllService } from '../../home/home-bll.service';
import { EventDetailsResponseModel } from '../../home/home.model';
@Component({
  selector: 'app-photo-upload',
  imports: [LeftSideNavComponent, HeaderComponent, CommonModule],
  templateUrl: './photo-upload.component.html',
  styleUrl: './photo-upload.component.scss'
})
export class PhotoUploadComponent implements OnInit {
  uploadedImg: string | ArrayBuffer | null = '';
  faceDetected: boolean = false;
  allowedFileTypes: string[] = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/svg",
  ]; // Array of strings
  maxFileSize: number = 15 * 1024 * 1024; // Number (15 MB in bytes)
  logoTitle: string = '';
  invalidImages: string = '';
  selectedFiles: (File | null) = null;
  previewLogos: string = '';
  encodedTicketCode: string = '';
  photoUploadSuccess: boolean = false;

  eventDetails: EventDetailsResponseModel | null = null;
  
   /**
   * Stores the user's profile information for the virtual event.
   *
   * This property is initialized as `null` and is expected to be populated with
   * the `user_profile` data from the `UserEventStatusRespModel` interface.
   */
   userProfile: UserEventStatusRespModel["user_profile"] | null = null;
  constructor(
    private ticketsBll: TicketsBllService,
    private router: Router,
    private loaderService: LoaderService,
    private profileBllService: ProfileBllService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private homeBll: HomeBllService,
  ) { }
  async ngOnInit(): Promise<void> {
    this.fetchUserEventStatus();
    // await this.ticketsBll.loadModels();
    
    this.activatedRoute.queryParams.subscribe(params => {
      this.encodedTicketCode = params['code'] || '';
    });

    this.loadEventDetails();
  }

  goback(): void {
    this.router.navigate(['/reg/ticket-details'], {
      queryParams: {
        code: this.encodedTicketCode,
      },
    });
  }

  onFileSelected(event: any): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    this.faceDetected = false;
    const file = input.files[0];

    // Validate file type
    if (!this.allowedFileTypes.includes(file.type)) {
     
      return;
    }

    // Validate file size
    if (file.size > this.maxFileSize) {
     
      return;
    }
     // Normalize extension to lowercase
     const fileName = file.name;
     const ext = fileName.split('.').pop()?.toLowerCase() ?? "";
     const base = fileName.substring(0, fileName.lastIndexOf(".")) || fileName;
 
     // build final lowercase extension name
     const normalizedName = `${base}.${ext}`;
 
     // Create a new File object with updated name
     const normalizedFile = new File([file], normalizedName, { type: file.type });
 
     // Store lowercase filename for UI or upload
     this.logoTitle = normalizedName;
 
     // Replace original file with normalized file
     this.selectedFiles = normalizedFile;
 
   
    const reader = new FileReader();
    reader.onload = async () => {
      const base64 = reader.result as string;
      this.uploadedImg = base64;
      this.invalidImages = "";

      this.photoUploadSuccess = true;
     
    };
    reader.readAsDataURL(normalizedFile);

  }

     /**
       * Fetches the current user's event status asynchronously and updates the user profile information.
       *
       * This method displays a loader while fetching data, retrieves the user's event status from the backend,
       * and updates the user service with the user's profile details such as name, profile image, mobile, state, and city.
       * If an error occurs during the fetch, it logs the error and displays an alert to the user.
       * The loader is hidden after the operation completes, regardless of success or failure.
       *
       * @returns {Promise<void>} A promise that resolves when the user event status has been fetched and processed.
       */
      private async fetchUserEventStatus(): Promise<void> {
        this.loaderService.show();
        try {
          const res: BaseResponse<UserEventStatusRespModel> = await this.profileBllService.submitGetUserEventStatus();
          this.userProfile = res.data.user_profile;
    
          if (this.userProfile) {
            const previewLogo =
              this.userProfile.image_url ??
              "/assets/images/Default-profile-photo.png";
            const userName = `${this.userProfile.first_name} ${this.userProfile.last_name}`;
            this.userService.setUser({
              name: userName,
              profileImg: previewLogo,
              mobile: this.userProfile.mobile,
              state: this.userProfile.state,
              city: this.userProfile.city,
              hasUnassignedTickets: res.data.event_my_tickets.unassigned_tickets_bought_by_me > 0,
              hasAssignedTickets: res.data.event_my_tickets.assigned_tickets_bought_by_me > 0 || res.data.event_my_tickets.tickets_assigned_for_me > 0,
    
            });
          }
          this.loaderService.hide();
        } catch (err) {
          this.loaderService.hide();
          console.error("Error fetching user event status:", err);
          alert("Failed to fetch user event status. Please try again.");
        }
      }

      onSubmit() {
        if (this.selectedFiles) {
          const payload: UpgradeTicketMediaPayload= {
            file_name_with_extension: '',
          };
          this.callgetImageUploadLinkAPI(
            this.selectedFiles,
            payload,
            this.encodedTicketCode,
            0
          );
        }
      }

      /**
         * Call the API to get the image upload link
         */
        callgetImageUploadLinkAPI(
          selectedFile: File,
          payload: any,
          encodedTicketCode: string,
          i: number
        ) {
          this.loaderService.show();
          this.ticketsBll
            .getImageUploadLinkChallenge(selectedFile.name, encodedTicketCode)
            .then((response) =>
              this.handleUploadImageLinkStatusSuccess(
                response,
                selectedFile,
                payload,
                encodedTicketCode
              )
            )
            .catch((err: APIErrorModel) =>
              this.handleUploadImageLinkStatusError(err)
            );
        }

  /**
   * Handle the successful response for the image upload link.
   * @param response The API response containing the upload link.
   * @param selectedFile The file to be uploaded.
   * @param payload The request payload.
   * @param encodedTicketCode The encoded ticket code.
   */
    handleUploadImageLinkStatusSuccess(
      response: any,
      selectedFile: File,
      payload: any,
      encodedTicketCode: string,
    ) {
      this.ticketsBll
        .uploadImageToS3(
          response.data.s3_media_post.url,
          response.data.s3_media_post.fields,
          selectedFile
        )
        .then((res) => {
          // After successful upload, call assign ticket API
          // Extract file_name_with_extension from response
          if (response.data?.file_name_with_extension) {
            payload.file_name_with_extension =
              response.data.file_name_with_extension;
            this.callUpdateTicketmedia(payload, encodedTicketCode);
          }
        })
        .catch((err) => {
          this.loaderService.hide();
          console.error("Error uploading image:", err);
        });
    }
  
    /**
   * Handle the error response for the image upload link.
   * @param err The error object from the API call.
   */
  handleUploadImageLinkStatusError(err: APIErrorModel): void {
    this.loaderService.hide();
    console.error("Error fetching image upload link:", err);
  }

  callUpdateTicketmedia(payload: UpgradeTicketMediaPayload, encodedTicketCode: string) {
    this.loaderService.show();
    this.ticketsBll.upgradeTicketImage(encodedTicketCode, payload)
      .then((response) =>
        this.handleUploadTicketMediaSuccess(response)
      )
      .catch((err: APIErrorModel) =>
        this.handleUploadTicketMediaError(err)
      );
    }

    /**
     * Handle the successful response for assigning a ticket.
     * @param response The API response after assigning the ticket.
     */
    handleUploadTicketMediaSuccess(response: any) {
      this.loaderService.hide();
      // Navigate to the tickets page or show a success message
      this.router.navigate(["/reg/ticket-details"], {
        queryParams: {
          code: this.encodedTicketCode,
          imgUploaded: 'true'
        },
      });
    }

    /**
     * Handle the error response for assigning a ticket.
     * @param err The error object from the API call.
     */
    handleUploadTicketMediaError(err: APIErrorModel): void {
      this.loaderService.hide();
      console.error("Error assigning ticket:", err);
    }


    public loadEventDetails() {
    this.homeBll.fetchEventDetails()
      .then((response) => {
        this.eventDetails = response.data;     
        this.userService.setLeftMenu({
          allow_to_register: this.eventDetails.allow_to_register,
          show_digital_catalog: this.eventDetails.show_digital_catalog,
          event_status: this.eventDetails.event_status
        });       
      })
      .catch((error) => {
        console.error('Error fetching event details:', error);
      });
  }
}
